function getNav() {

    return document.querySelector('.js_aboutNav');
}

function getStickyNav() {

    return document.querySelector('.js_aboutNav--sticky');
}

function showStickyNav(stickyNav) {
    stickyNav.classList.remove('aboutNav--hidden');
}

function hideStickyNav(stickyNav) {
    stickyNav.classList.add('aboutNav--hidden');
}

function toggleSticky(entries, observer) {
    const entry = entries[0];
    const stickyNav = getStickyNav();

    if (!stickyNav) {
        return;
    }

    if (!entry.isIntersecting) {
        showStickyNav(stickyNav);
    } else {
        hideStickyNav(stickyNav);
    }
}

function init() {
    const nav = getNav();
    
    if (nav) {
        const options = {
            root: null,
            threshold: 1.0,
        };

        const observer = new IntersectionObserver(toggleSticky, options);

        observer.observe(nav);
    }
}

$(document).ready(init);
